export default [
  {
    title: 'مدیریت عمومی',
    icon: 'bx bx-chalkboard',
    children: [
      {
        title: 'کشورها',
        route: { name: 'country' },
        resource: 'CountryManager',
        action: 'show',
      },
      {
        title: 'استان ها',
        route: { name: 'state' },
        resource: 'StateManager',
        action: 'show',
      },
      {
        title: 'شهرها',
        route: { name: 'city' },
        resource: 'CityManager',
        action: 'show',
      },
    ],
  },
]
